module.exports = __webpack_public_path__ + "static/img/wb_qrcode.f4104354.jpg";